import { render, staticRenderFns } from "./PasswordResetMailSentPage.vue?vue&type=template&id=b3afe220"
import script from "./PasswordResetMailSentPage.vue?vue&type=script&lang=ts"
export * from "./PasswordResetMailSentPage.vue?vue&type=script&lang=ts"
import style0 from "./PasswordResetMailSentPage.vue?vue&type=style&index=0&id=b3afe220&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports